import { TKioskClockOutData } from 'types/kiosk/TKioskClockOutData';
import { TKioskPolicy } from 'types/kiosk/TKioskStartRegistrationData';
import { toKioskPoliciesByLanguage } from './kiosk-start-registration-data-mapper';
import { asArray, asRecords, toNumberOrNull, toStringOrNull } from './mapper-utils';

const toPolicies = (rows: unknown[]): TKioskPolicy[] =>
  asRecords(rows).map(r => ({ key: String(r.key ?? ''), label: String(r.label ?? '') }));

/** Maps the raw ClockOutData body (treated as unknown) to a typed shape.
 *  Returns null for a non-object / empty / id-less body. The 204 "no active registration"
 *  case is handled at the request layer (a sentinel), not here. */
export const fromResponseToKioskClockOutData = (response: unknown): TKioskClockOutData | null => {
  if (typeof response !== 'object' || response === null) return null;
  const body = response as Record<string, unknown>;
  if (!body.id) return null;
  return {
    id: Number(body.id),
    costCentreName: toStringOrNull(body.costCentreName),
    startTime: String(body.startTime ?? ''),
    plannedStartTime: toStringOrNull(body.plannedStartTime),
    plannedEndTime: toStringOrNull(body.plannedEndTime),
    plannedTotalMinutes: toNumberOrNull(body.plannedTotalMinutes),
    serverNowUtc: toStringOrNull(body.serverNowUtc),
    maximumNumberOfBreaks: toNumberOrNull(body.maximumNumberOfBreaks) ?? 0,
    policies: toPolicies(asArray(body.policies)),
    policiesByLanguage: toKioskPoliciesByLanguage(body.policiesByLanguage),
  };
};
